import { FHTDeviceType } from "@/models/MessageTypes";
export function getDeviceType(avMsg) {
  var attr = avMsg.attributes; // assert(attr, "attr falsy");

  var dt = (attr === null || attr === void 0 ? void 0 : attr.dt) || FHTDeviceType.Web;
  return dt;
}